import type { ThemeDefaultParams } from 'ag-grid-community';

export const agGridThemeParams: Partial<ThemeDefaultParams> = {
  accentColor: 'var(--twc-primary, #24c9a7)',
  backgroundColor: 'transparent',
  borderColor: 'var(--twc-border)',
  cellHorizontalPadding: 12,
  checkboxBorderRadius: 2,
  checkboxBorderWidth: '1.6px',
  checkboxCheckedBackgroundColor: 'var(--twc-primary, #24c9a7)',
  checkboxIndeterminateBackgroundColor: 'var(--twc-primary, #24c9a7)',
  checkboxUncheckedBackgroundColor: 'transparent',
  checkboxUncheckedBorderColor: 'var(--twc-border, #EBECEC)',
  dataBackgroundColor: 'transparent',
  focusShadow: 'none',
  textColor: 'var(--twc-primary-typeface)',
  fontFamily: 'inherit',
  fontSize: 14,
  foregroundColor: 'rgba(0, 0, 0, 0.87)',
  headerBackgroundColor: 'transparent',
  headerCellBackgroundTransitionDuration: '0s',
  headerCellHoverBackgroundColor: 'var(--twc-hovered-color, #0B4A3D0F)',
  headerColumnResizeHandleColor: 'var(--twc-primary-typeface, #03120F)',
  headerColumnResizeHandleHeight: '100%',
  headerColumnResizeHandleWidth: 1,
  headerFontSize: 13,
  headerHeight: 38,
  oddRowBackgroundColor: 'transparent',
  pinnedColumnBorder: false,
  rowHeight: 44,
  rowHoverColor: 'rgba(11, 74, 61, 0.04)',
  selectCellBorder: false,
  selectedRowBackgroundColor: 'transparent',
  spacing: 4,
  wrapperBorderRadius: 0,
};
